import { Action, createAction, createReducer, on, props } from '@ngrx/store';

export const refreshLoan = createAction('[Loan] Refresh Loan List');
